import { Height } from "@mui/icons-material";

export const getWidthChart = (filters: { option: number; user: number }, labelsCount: number) => {
  
  if (
    filters?.option === 1 ||
    filters?.option === 2 ||
    filters?.option === 5 ||
    (filters?.option === 3 && labelsCount <= 31) ||
    (filters?.option === 4 && labelsCount <= 31) ||
    (filters?.option === 5 )
  ) {
    return '98vw';
  } else {
    if ((filters?.option === 8) && labelsCount > 10) {
      return `calc((97vw / 10) * ${labelsCount})`;
    } else {
      return '98vw';
    }
  }
};

export const getHeightChart = (filters: { option: number; user: number }, labelsCount: number) => {
  const { option, user } = filters;

  if ((labelsCount <= 13)){
    return {
      height: `calc(75vh - 80px)`,
      overflow: 'hidden'
    } 
  } else if ((option === 4 || option === 5) && labelsCount < 20) {
    return {
      height: `calc((74vh / 20) * ${labelsCount})`,
      overflow: 'hidden' 
    };
  } else {
    return {
      height: `calc((82vh / 15) * ${labelsCount})`,
      overflow: 'scroll'
    };
  }


  // if ((option === 3) || (labelsCount <= 10)) {
  //   if (option === 5 && labelsCount > 30) {
  //     return `calc((80vh / 30) * ${labelsCount})`;
  //   } else if (option === 4 || option === 5 || option === 6 || option === 7) {
  //     return `calc(80vh - 80px)`;
  //   } else {
  //     return `calc((80vh / 20) * ${labelsCount})`;
  //   }
  // } else {
  //   if (user > 0) {
  //     if (labelsCount <= 15) {
  //       return 'calc(82vh - 80px)';
  //     } else {
        
  //     }
  //   } else {
  //     return `calc((82vh / 5) * ${labelsCount})`;
  //   }
  // }
};

export const getLegendPosition = (option: number, orientation: string) => {

  const optionsDisplay = [8, 9]
  let position = 'top';
  let align = 'center';

  if (option > 2 || orientation === 'y') {
    align = 'start';
  }
  return {
    display: optionsDisplay.includes(option) ? true : false,  
    position: position,
    align: align,
  };
};
